export interface State {
  example?: number // fake
}

export enum Types {
  SetExample = 'SET_EXAMPLE', // fake
}

export type Payload = {
  [Types.SetExample]: number // fake
}

type ActionMap<T> = {
  [Key in keyof T]: T[Key] extends undefined
    ? {
        type: Key
      }
    : {
        type: Key
        payload: T[Key]
      }
}

export type Actions = ActionMap<Payload>[keyof ActionMap<Payload>]
